import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createstation(data) {
    let response = await apiCall("stations/create", data);
    return response;
  },
  async liststations(data) {
    let response = await apiCall("stations/list/stations", data);
    return response;
  },
  async get_station_mother_company_id(data) {
    let response = await apiCall("stations/get_station_mother_company", data);
    return response;
  },
  async liststations_mini_data(data) {
    let response = await apiCall("stations/list/stations_mini_data", data);
    return response;
  },
  async get_station_name(data) {
    let response = await apiCall("stations/get_a_station_name", data);
    return response;
  },
  async update_fuel_category(data) {
    let response = await apiCall("stations/update_station", data);
    return response;
  },
};
